export const validateStringArea = (maxLength: number, input: string): boolean => {
  const trimmed = input.trim();
  const nonSpaceCount = trimmed.replace(/\s/g, '').length;

  return nonSpaceCount < maxLength;
};
